var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_button",
    transform: "translate(-278 -1339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M26,0H0V26H26Z",
    transform: "translate(278 1339)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2149",
    "data-name": "Group 2149",
    transform: "translate(-9361.515 1735.485)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(9641.515 -394.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-close-circle",
    "data-name": "Icon ionic-ios-close-circle",
    d: "M13.851,3.375A10.476,10.476,0,1,0,24.327,13.851,10.474,10.474,0,0,0,13.851,3.375Zm2.654,14.268-2.654-2.654L11.2,17.643a.8.8,0,1,1-1.138-1.138l2.654-2.654L10.058,11.2A.8.8,0,0,1,11.2,10.058l2.654,2.654,2.654-2.654A.8.8,0,0,1,17.643,11.2l-2.654,2.654,2.654,2.654a.809.809,0,0,1,0,1.138A.8.8,0,0,1,16.505,17.643Z",
    transform: "translate(9638.664 -397.337)",
    fill: "#ff6080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close_button.cc16084b50183c29187ba42508ea8337.svg";
export { ForwardRef as ReactComponent };